import './App.sass'

import Main from './components/main';
import Footer from './components/footer';

function App() {
  return (
    <section className='app'>
      <Main />
      <Footer/>
    </section>
  );
}

export default App;
